function ReturnSummary({ data }) {
  return (
    <div
      className="card shadow-sm border-0"
      style={{ maxWidth: 420, margin: "auto" }}
    >
      {/* HEADER */}
      <div className="card-body text-center">
        <div className="text-success fs-3">✔</div>
        <h5 className="fw-bold mb-0">Item Returned</h5>
        <p className="text-muted">Transaction completed</p>
      </div>

      {/* DEPOSIT REFUND */}
      <div className="mx-3 p-3 rounded bg-success bg-opacity-10 mb-2">
        <div className="d-flex justify-content-between">
          <span>💰 Deposit refunded</span>
          <strong className="text-success">
            ₹{data.depositRefund}
          </strong>
        </div>
      </div>

      {/* PENALTY */}
      <div className="mx-3 p-3 rounded bg-warning bg-opacity-10 mb-2">
        <div className="d-flex justify-content-between">
          <span>⚠ Late penalty</span>
          <strong className="text-danger">
            -₹{data.penalty}
          </strong>
        </div>
      </div>

      {/* OWNER PAYOUT */}
      <div className="mx-3 p-3 rounded bg-primary bg-opacity-10 mb-3">
        <div className="d-flex justify-content-between">
          <span>🏠 Rent credited to owner</span>
          <strong className="text-primary">
            {data.ownerPayoutStatus === "processed"
              ? "Processed"
              : "Pending"}
          </strong>
        </div>
      </div>

      <hr />

      {/* NET REFUND */}
      <div className="px-3 pb-3">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-semibold">Net refund</span>
          <span className="fs-5 fw-bold text-success">
            ₹{data.netRefund}
          </span>
        </div>

        <p className="text-muted small mt-1">
          Amount will be credited to your account within 3–5 business days
        </p>

        <button className="btn btn-primary w-100 mt-2">
          View Transaction Details
        </button>
      </div>
    </div>
  );
}

export default ReturnSummary;

